import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import moment from "moment";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { ApiService } from "src/app/services/api.service";
import { SessionService } from "src/app/services/session.service";

@Injectable({
  providedIn: "root",
})
export class DynamicFilterService {
  moment = moment;
  previousSingleSelectedItems: any = [];
  previousMultiSelectedItems: any = [];
  previousDateRangeSelectedDate: any = {};
  backupLoadedData: any = {};
  baseQuery: any;
  payload: any = [];
  refreshGrid = new Subject<any>();
  filterQuery = new Subject<any>();
  filterDetection = new Subject<any>();
  resetForm = new Subject<any>();
  deepCopyOfRowSelection: any = [];
  deepCopyOfDynamicRowSelection: any = [];
  updatedColumnValue: string = "";
  updatedWithHoldJiraColumnValue: string = "";
  updatedDynamicWithholdJiraColumn: string = "";
  processName: string = "";
  dynamicProcessMandatoryColumns: any = [];
  dynamicProcessObject: { [key: string]: any } = {};
  isCascadingDisabled: boolean = false;
  dynamicCheckboxColumnName: any;
  dvlogCascadingObject: { [key: string]: any } = {};
  updatedDvlogUpdatedColumnName: string = "";
  hiddenBadgeKeys: Set<string> = new Set<string>();

  fields: any;
  badges: any = [];
  dynamicBadges: any = [];

  selectedAllFilters: any = {};
  selectedFilters: any = {};
  resetBadge = false;

  exitstingModel: any;
  selectedProcessDetailsKey: any = {};
  selectedEndPointDetails: any = {};
  selectedprocess_master_key: any = {};
  customDesignedJsonDetails: any;
  selectedDQCMasterKey: any = {};
  selectedColumnName: any = {};
  selectedDefectType: any = {};
  private booleanSubject = new BehaviorSubject<boolean>(false); // Initial value
  boolean$ = this.booleanSubject.asObservable();

  private filterValueResponseSubject = new BehaviorSubject<any>(null); // Initial value
  filterValueResponse$ = this.filterValueResponseSubject.asObservable();

  private dynamicFilterRowDataSubject = new BehaviorSubject<any>([])
  dynamicFilterRowData$ = this.dynamicFilterRowDataSubject.asObservable();

  clientKey: any;
  screenName: string = '';
  constructor(private apiService: ApiService, private sessionService: SessionService, private router: Router) {
  }

  getScreenName() {
    const currentUrl = this.router.url;
    const lowerUrl = currentUrl.toLowerCase();

    if (lowerUrl.includes('dynamic-crud-insert-monitor')) {
      this.screenName = 'CRUD Insert Screen';
    } else if (lowerUrl.includes('dynamic-process-monitor')) {
      this.screenName = 'CRUD Screen';
    } else if (lowerUrl.includes('email-report-monitor')) {
      this.screenName = 'Email_Report_Monitor';
    } else {
      this.screenName = 'Unified Screen';
    }
  }
  // Method to add or update key-value pairs
  objectHasValueSubject = new BehaviorSubject<boolean>(false);
  objectHasValue$ = this.objectHasValueSubject.asObservable();
  addOrUpdateDynamicProcessObject(key: string, value: any): void {
    this.dynamicProcessObject[key] = value; // Add new key or update existing key
    // Check if the object has any values and emit the result
    const hasValues = Object.keys(this.dynamicProcessObject).some(
      (k) => this.dynamicProcessObject[k] != null && this.dynamicProcessObject[k] !== '' && this.dynamicProcessObject[k] !== undefined
    );
    this.objectHasValueSubject.next(hasValues);
  }


  addOrUpdateDvlogCascadingObject(key: string, value: any) {
    this.dvlogCascadingObject[key] = value;
    const hasValues = Object.keys(this.dvlogCascadingObject).some(
      (k) => this.dvlogCascadingObject[k] != null && this.dvlogCascadingObject[k] !== '' && this.dvlogCascadingObject[k] !== undefined
    );
    this.objectHasValueSubject.next(hasValues);
    // console.log('Global Object:', this.dvlogCascadingObject); // Log the current state
  }

  setBoolean(value: boolean) {
    this.booleanSubject.next(value);
  }

  updateFilterValueData(data: any) {
    this.filterValueResponseSubject.next(data);
  }

  updateDynamicFilterRowData(data: any) {
    this.dynamicFilterRowDataSubject.next(data)
  }

  loadApiDataDynamicFilter(opt: any, data: any) {

    if (opt.method.toLowerCase() == 'post') {
      let request: any = {};

      let keys = opt.parameter.split(",");

      for (let k of keys) {
        let keyName = k;

        if (data[keyName] instanceof Array) {
          request[keyName] = data[keyName] ? this.getFilter(data[keyName], keyName) : "";
        } else {
          request[keyName] = data[keyName] ? data[keyName][keyName] : "";
        }
      }

      if (opt.filterQuery) {
        request['filter_query'] = opt.filterQuery;
      }

      // let combinePayload = {...this.exitstingModel,...request,...this.selectedProcessDetailsKey };
      let combinePayload = this.mergeWithPriority(this.exitstingModel, request, this.selectedProcessDetailsKey);
      request = combinePayload;

      return this.apiService.post(opt.dataSourceUrl, request);
    } else {
      return this.apiService.get(opt.dataSourceUrl);
    }
  }

  mergeWithPriority(...objects: any) {
    return objects.reduce((acc: any, obj: any) => {
      for (let key in obj) {
        if (obj[key] !== "" && obj[key] !== null && obj[key] !== undefined) {
          acc[key] = obj[key];
        }
      }
      return acc;
    }, {});
  }

  loadApiData(method: string, url: string, key: string, data: any) {
    if (method.toUpperCase() == "POST") {
      let request: any = {};

      let keys = key.split(",");

      for (let k of keys) {
        let keyName = k;

        if (data[keyName] instanceof Array) {
          request[keyName] = data[keyName]
            ? this.getFilter(data[keyName], keyName)
            : "";
        } else {
          request[keyName] = data[keyName] ? data[keyName][keyName] : "";
        }
      }
      if (url == 'api/filter/get-sub-process-details') {
        this.exitstingModel = request;
      }
      console.log("screen name before api call", this.screenName, "url ", url);
      
      if (url === 'api/filter/get-process-details') {
        request.screen_nm = this.screenName;
        return this.apiService.post(url, request);
      } else if (this.screenName === 'Email_Report_Monitor' && url === 'api/filter/get-active-brand-filter') {
        request.screen_nm = this.screenName;
        return this.apiService.post(url, request);
      } else {
        return this.apiService.post(url, request);
      }

    } else {
      return this.apiService.get(url);
    }
  }

  setFilterValue(values: any) {
    // debugger
    // auto query stored based on formly form data
    const query: any = {};
    for (let [key, value] of Object.entries(values)) {
      if (value instanceof String) {
        query[key] = value;
      } else if (value instanceof Date) {
        query[key] = moment(value).format("yyyy-MM-DD");
      } else if (value instanceof Object) {
        const v: any = value;
        if (v[key] == undefined) {
          // let a: string = v?.map((a: any) => a[key]);
          // query[key] = a.toString();
          if (Array.isArray(v)) {
            const a = v.map((item: any) => item[key]);
            query[key] = a.toString();
          } else {
            // Handle non-array object case gracefully
            query[key] = v[key] ?? '';
          }
        } else {
          query[key] = v[key];
        }
      } else if (value instanceof Array) {
        query[key] = this.getFilter(value, key);
      } else {
        query[key] = value;
      }
    }

    // Main
    this.baseQuery = query;
    this.filterQuery.next(this.baseQuery);
    this.resetFilterChange();
  }

  getFilter(data: any[], paramName: any) {
    if (data.length == 0) return null;
    let filter = "";
    data.map((e) => {
      filter += e[paramName] + ",";
    });
    return filter.slice(0, filter.lastIndexOf(","));
  }

  getDvlogData() {
    if (!this.baseQuery) return new Observable((ob) => ob.next(undefined));
    let query = Object.assign({}, this.baseQuery);
    return this.apiService.post("api/dvlog/get-dvlog-data", query);
  }

  smokeTestFilterDetection = new Subject<any>();
  getSmokeTestData() {
    if (!this.baseQuery) return new Observable((ob) => ob.next(undefined));
    let query = Object.assign({}, this.baseQuery);
    query = { ...query, ...this.selectedDefectType };
    if (query.unique_sequence_id) {
      query.report_sql_key = query.unique_sequence_id;
    }
    return this.apiService.post("api/smoketest/get-smoketest-data", query);
  }

  emailMonitorFilterDetection = new Subject<any>();
  pickSelectedKeys(keys: string[]): any {
    const result: any = {};

    if (!this.baseQuery) return new Observable((ob) => ob.next(undefined));
    let query = Object.assign({}, this.baseQuery);
    keys.forEach((key) => {
      if (key in query) {
        result[key] = query[key];
      }
    });
    return result;
  }

  postValidateSqlQuery(data: any) {
    let query = Object.assign({}, this.baseQuery);
    let payload = { ...query, ...data }
    console.log("payload 372", payload);
    return this.apiService.post("api/smoketest/validate-smoketest-query", payload);
  }

  postUpdateSmokeTestData(data: any) {
    return this.apiService.post("api/smoketest/update-smoketest-data", data);
  }

  postDeleteSmokeTestData(data: any) {
    return this.apiService.post("api/smoketest/update-smoketest-status", data);
  }

  postAddSmokeTestData(data: any) {
   // if (!this.baseQuery) return new Observable((ob) => ob.next(undefined));
    let query = Object.assign({}, this.baseQuery);
    let userClientKey = { client_key: this.sessionService.getClientKey(), user_id: this.sessionService.getUsername() };
    let payload = { ...query, ...data, ...this.selectedDQCMasterKey, ...this.selectedColumnName, ...userClientKey, ...this.selectedDefectType }
    // ✅ Remove etl_workflow_key if it has no value
    if (!payload.etl_workflow_key) {
      delete payload.etl_workflow_key;
    }
    let finalOutPut = { message: JSON.stringify(payload) };
    return this.apiService.post("api/smoketest/insert-smoke-test-info", finalOutPut);
  }

  getSmokeTestResultUpdateById(id: any): Observable<any> {
    return this.apiService.get(`api/smoketest/get-sqs-response-by-message-id/${id}`);
  }

  getDvlogCommentsData() {
    // if (!this.baseQuery) return new Observable((ob) => ob.next(undefined));
    return this.apiService.get("api/filter/get-comments");
  }

  dVlogDeleteRecords(data: any) {
    return this.apiService.post("api/dvlog/delete-dvlog-records", data);
  }
  getDeleteLogs(data: any) {
    return this.apiService.post("api/dvlog/get-dvlogstatus-data", data);
  }

  getDynamicProcessData() {
    //  if (!this.baseQuery) return new Observable((ob) => ob.next(undefined));
    let query = Object.assign({}, this.baseQuery);
    query = { ...query, ...this.exitstingModel, ...this.selectedProcessDetailsKey }
    return this.apiService.post("api/ProcessLog/get-process-data", query)
  }

  getDynamicEditableColumnName() {
    let query = Object.assign({}, this.baseQuery);
    query = { ...query, ...this.exitstingModel, ...this.selectedProcessDetailsKey }
    return this.apiService.post("api/filter/get-process-columns", query)
  }

  getDynamicDropdownColumnData(data: any) {
    return this.apiService.post("api/filter/get-column-values", data)
  }

  getDynamicCustomFilterFields(data: any) {
    return this.apiService.post("api/filter/get-filter-config", data)
  }

  getDvlogStatus(data: any) {
    return this.apiService.post("api/dvlog/get-dvlogdelete-status", data);
  }

  updateDynamicCrudOperationMonitorData(selectedRow: any) {
    let payload = [];
    let process_id = { process_id: this.sessionService.getLogSession().session_id + String(new Date().getTime()) }
    payload = { ...this.exitstingModel, ...this.selectedProcessDetailsKey, ...process_id, data: selectedRow };
    return this.apiService.post("api/ProcessLog/update-process-data", payload)
  }

  insertDynamicCrudOperation(data: any) {
    let payload = {
      process_detail_key: this.selectedProcessDetailsKey.process_detail_key,
      payload: data
    };
    return this.apiService.post("api/ProcessLog/insert-process-data", payload)
  }

  isEmptyObject(obj: any) {
    return Object.keys(obj).length === 0;
  }

  setBadges(fields: any) {
    this.badges = [];

    fields.forEach((f: any) => {
      const exist = this.badges.find((b: any) => b.key == f.key);

      if (!exist) {
        this.badges.push({
          key: f.key,
          allOpt: "",
          selectedOpt: "",
          label: f.templateOptions.label,
          type: f.templateOptions.type,
          showBy: f.templateOptions.showBy,
          labelProp: f.templateOptions.labelProp,
        });
      }
    });
  }

  setDynamicBadges(fields: any) {
    this.dynamicBadges = [];

    fields.forEach((f: any) => {
      const exist = this.badges.find((b: any) => b.key == f.key);

      if (!exist) {
        this.dynamicBadges.push({
          key: f.key,
          allOpt: "",
          selectedOpt: "",
          label: f.templateOptions.label,
          type: f.templateOptions.type,
          showBy: f.templateOptions.showBy,
          labelProp: f.templateOptions.labelProp,
        });
      }
    });
  }

  resetFilter() {

    let data: any = sessionStorage.getItem("userState");
    data = JSON.parse(data);
    data.selectedFilters = {};
    sessionStorage.setItem("userState", JSON.stringify(data))
    this.resetForm.next(true);
    this.resetBadge = false;
    this.filterDetection.next(true);
  }

  resetFilterChange() {
    let foundChanges = Object.keys(this.selectedAllFilters).find((key) => {
      if (JSON.stringify(this.selectedAllFilters[key]) !== JSON.stringify(this.selectedFilters[key])) {
        return true; // Found a difference
      }
      return false; // No difference found for this key
    });

    if (foundChanges) {
      this.resetBadge = true;
    } else {
      this.resetBadge = false;
    }
  }

  setBadgeValue(key: string, allOpt: any, selectedOpt: any) {
    this.badges.find((b: any) => {
      if (b.key == key) {
        b.allOpt = allOpt;
        b.selectedOpt = selectedOpt;
      }
    });
  }

  setDynamicBadgeValue(key: string, allOpt: any, selectedOpt: any) {
    this.dynamicBadges.find((b: any) => {
      if (b.key == key) {
        b.allOpt = allOpt;
        b.selectedOpt = selectedOpt;
      }
    });
  }

  formlyDataNewFilterIndication = new Subject<any>();

  private formlyData = new BehaviorSubject<any[]>([]);
  formlyData$ = this.formlyData.asObservable();

  private dropDownOption = new BehaviorSubject<any[]>([]);
  dropDownOption$ = this.dropDownOption.asObservable();

  setFormlyData(data: any[]) {
    this.formlyData.next(data);
  }

  setDropDown(data: any[]) {
    this.dropDownOption.next(data);
  }

  getUpdatedRecords(initialArray: any[], updatedArray: any[], columnConfigs: { operation_col_nm: string }[]): any[] {
    //console.log("updatedArray", updatedArray, "columnConfigs", columnConfigs, "initialArray", initialArray);

    return updatedArray.filter((updatedRecord) => {
      const matchingRecord = initialArray.find(
        (initialRecord) => initialRecord["record_seq_key"] === updatedRecord["record_seq_key"]
      );

      if (!matchingRecord) return true; // New record, always include it

      // Check if all specified columns have changed (excluding null → "")
      const allColumnsChanged = columnConfigs.every((config) => {
        const columnName = config.operation_col_nm.toLowerCase();
        const oldValue = matchingRecord[columnName];
        const newValue = updatedRecord[columnName];

        // Treat null and empty string as the same (not a significant change)
        if ((oldValue === null || oldValue === "") && (newValue === null || newValue === "")) {
          return false; // No significant change
        }

        return oldValue !== newValue; // Significant change
      });

      return allColumnsChanged; // Only return records where all columns changed
    });
  }

  getUnifiedData() {
    //  if (!this.baseQuery) return new Observable((ob) => ob.next(undefined));
    let query = Object.assign({}, this.baseQuery);
    query = { ...query, ...this.exitstingModel, ...this.selectedProcessDetailsKey }
    return this.apiService.post("api/ProcessLog/get-process-data", query)
  }

  postUnifiedDetailsModification(data: any) {
    let query = Object.assign({}, this.baseQuery);
    //console.log("this.baseQuery", {...this.exitstingModel, ...this.selectedProcessDetailsKey,...query});
    let paylod = { ...query, ...data, ...this.exitstingModel, ...this.selectedProcessDetailsKey }
    if (this.selectedEndPointDetails == "api/file-processing-chevron/insert-manual-file-data") {
      let extraPayload = this.mapAndUpdateValues(paylod);
      paylod = { ...paylod, ...extraPayload }
    } else {
      paylod = { ...paylod, process_id: this.sessionService.getLogSession().session_id + String(new Date().getTime()) }
    }


    return this.apiService.post(`${this.selectedEndPointDetails}`, paylod);
  }

  getUnifiedProcessLogData() {
    let query = Object.assign({}, this.baseQuery);
    let filterKey = this.mapFilterKey(query);
    let payload = {
      "process_detail_key": this.selectedProcessDetailsKey.process_detail_key,
      ...filterKey
    };
    return this.apiService.post("api/file-processing-chevron/get-unified-log-info", payload);
  }

  uploadExcelFile(data: FormData): Observable<any> {
    return this.apiService.postFormData("api/file-processing/upload-excel-files", data);
  }

  mapAndUpdateValues(source: any): any {
    let result = {};
    result = {
      ds_key: source.ds_key,
      ExpectedEndDate: source.expected_end_date,
      brandKey: source.brand_key,
      actual_end_date: source.actual_end_dt,
      clientKey: source.client_key,
      files: source.file_key,
      process_id: this.sessionService.getLogSession().session_id + String(new Date().getTime()),
      username: source.user_id,
      update_user_id: source.user_id,
      comments: "",
    }
    return result
  }

  mapFilterKey(payload: any): any {
    let result = {};
    result = {
      filter_key: this.selectedprocess_master_key.process_desc == 'Auto To Manual File Process' ? payload.file_key : payload.report_key
    }
    return result;
  }

  // dv ds apis
  getDVDSfiltereddata() {
    if (!this.baseQuery) return new Observable((ob) => ob.next(undefined));
    let query = Object.assign({}, this.baseQuery);
    return this.apiService.post("api/filter/get-ds-dv-info", query)
  }

}
